import { takeLatest } from 'redux-saga/effects'
import { SET_CHAT_LIMIT_SAGA } from 'src/store/types/adminData'
import setChatLimit from './setChatLimit'

export function* setChatLimitSaga() {
  yield takeLatest(SET_CHAT_LIMIT_SAGA, setChatLimit)
}
